module.exports = __webpack_public_path__ + "static/img/pro2_scene.9751c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro2_scene.png
// module id = xlU+
// module chunks = 0